import React from 'react'

const LOading = () => {
  return (
    <div style={{margin:"auto", width:"20%", marginTop:"4rem"}}>
        <img src="https://cdn.booooooom.com/wp-content/uploads/2017/12/avatar-green.gif" alt="" />
    </div>
  )
}

export default LOading